var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.payments.length)?_c('div',{staticClass:"no-quietanze-wrapper"},[_c('p',[_vm._v("Nessuna quietanza collegata a questo titolo")])]):_c('div',{staticClass:"details-card-wrapper"},_vm._l((_vm.sections),function(section,index){return _c('info-card',{key:index,attrs:{"title":section.title,"rows":section.rows}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }